<template>
  <el-select v-loading="loading" ref="package" v-model="selected" :placeholder="$t('selecione-uma-opcao')"
    @change="update()">
    <el-option v-for="row of tableList" :key="row.id" :label="row.name" :value="row.id">
      <span style="float: left">{{ row.name }}</span>
      <span v-if="row.value" style="float: right; color: #8492a6; font-size: 13px">{{ row.value }}</span>
    </el-option>
  </el-select>
</template>

<script>
import { PackingService } from "@/services/customers/packing.services";
export default {
  name: "ReverseLogisticsPackage",
  data: function () {
    return {
      tableList: [],
      selected: "",
      loading: false,
    };
  },
  props: {
    current: String,
  },
  methods: {
    fetch() {
      const vm = this;
      vm.loading = true;
      PackingService.list('', '2')
        .then((response) => {
          vm.tableList = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => vm.loading = false);
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetch();
  },
};
</script>